var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleTwitter = function SvgCircleTwitter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.572 0h-24v24h24V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79 18.096c5.658 0 8.754-4.692 8.754-8.754 0-.132 0-.264-.006-.396a6.268 6.268 0 0 0 1.536-1.596 6.236 6.236 0 0 1-1.77.486 3.095 3.095 0 0 0 1.356-1.704 6.12 6.12 0 0 1-1.956.744 3.07 3.07 0 0 0-2.244-.972 3.08 3.08 0 0 0-3 3.78 8.737 8.737 0 0 1-6.342-3.216 3.085 3.085 0 0 0 .954 4.11 3.112 3.112 0 0 1-1.392-.384v.042a3.083 3.083 0 0 0 2.466 3.018 3 3 0 0 1-.81.108c-.198 0-.39-.018-.576-.054a3.077 3.077 0 0 0 2.874 2.136 6.17 6.17 0 0 1-3.822 1.32 5.92 5.92 0 0 1-.732-.042 8.752 8.752 0 0 0 4.71 1.374Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clip-path", {
    id: "twitter_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.572,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-twitter.874ef98279f4a42fc47d392301f5247f.svg";